(function () {
  function zoraliContrastColor(hex) {
    if (!hex) return null;
    var c = hex.replace('#', '');
    if (c.length === 3) {
      c = c.split('').map(function (ch) { return ch + ch; }).join('');
    }
    if (c.length !== 6) return null;
    var r = parseInt(c.substr(0, 2), 16);
    var g = parseInt(c.substr(2, 2), 16);
    var b = parseInt(c.substr(4, 2), 16);
    var luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
    return luminance > 0.6 ? '#000000' : '#ffffff';
  }

  // The "$X.XX" shown inside the Add to Cart button (.btn_price) isn't
  // server-rendered — assets/global.js copies it in from the visible price
  // display once, on that script's own initial load. It has no reason to
  // know about swapToProduct's DOM replacement, so re-run the same logic
  // ourselves after every swap or the button is left with an empty price.
  function syncBtnPrice() {
    var priceEl = document.querySelector('.product__info-wrapper.grid__item .price-item.price-item--last');
    var btnPrice = document.querySelector('.btn_price');
    if (!priceEl || !btnPrice) return;
    var cleaned = priceEl.textContent.replace(/[^$0-9.,]/g, '').replace(/^\./, '');
    btnPrice.textContent = cleaned;
  }

  // Dawn can replace the variant-selects (and sometimes the submit button)
  // with a freshly rendered node whenever the variant OR the whole section
  // changes (see swapToProduct below), so any reference captured once can go
  // stale/detached. Always look these up fresh at the moment they're needed.
  function getRealBtn() {
    return document.querySelector('[id^="ProductSubmitButton-"]');
  }
  function getVariantSelects() {
    return document.querySelector('[id^="variant-selects-"]');
  }

  function applyStickyBarColors() {
    var bar = document.querySelector('.zorali-sticky-bar');
    if (!bar) return;
    var swatchBg = bar.dataset.swatchBg;
    var swatchText = bar.dataset.swatchText;

    if (swatchBg && zoraliContrastColor(swatchBg) === '#000000') {
      // Light swatch colors (e.g. Beachwood) are barely visible against the
      // page's white background without a border to define the button edge.
      document.querySelectorAll('.zorali-sticky-bar__button').forEach(function (el) {
        el.style.border = '0.1rem solid #000';
      });
    }
    if (swatchBg && !swatchText) {
      var autoColor = zoraliContrastColor(swatchBg);
      if (autoColor) {
        document.querySelectorAll('.zorali-sticky-bar__button').forEach(function (el) {
          el.style.color = autoColor;
        });
      }
    }
  }

  function onStickyBarScroll() {
    var bar = document.querySelector('.zorali-sticky-bar');
    var realBtn = getRealBtn();
    if (!bar || !realBtn) return;
    var rect = realBtn.getBoundingClientRect();
    bar.classList.toggle('zorali-sticky-bar--visible', rect.bottom < 0);
  }

  // All listeners here are delegated to document/window and re-query fresh
  // elements at event time, so this only ever needs to run once — it keeps
  // working correctly after swapToProduct() replaces the section's DOM.
  function initStickyBar() {
    document.addEventListener('click', function (e) {
      if (e.target.closest('#ZoraliStickyBarBtn')) {
        var realBtn = getRealBtn();
        if (realBtn) realBtn.click();
      }
      if (e.target.closest('#ZoraliStickyBarChooseSize')) {
        var target = getVariantSelects() || getRealBtn();
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    });

    // Once the shopper has actively chosen a size, swap the label to
    // "Add to cart" — clicking still just scrolls back up to the real
    // button, it never submits the form directly from the sticky bar.
    document.addEventListener('change', function (e) {
      if (e.target.matches('input[type="radio"]') && e.target.closest('[id^="variant-selects-"]')) {
        var chooseBtn = document.getElementById('ZoraliStickyBarChooseSize');
        if (chooseBtn) chooseBtn.textContent = 'Add to cart';
        // Dawn's own variant-change AJAX patches the price display in
        // asynchronously, so wait a beat before re-reading it.
        setTimeout(syncBtnPrice, 150);
      }
    });

    window.addEventListener('scroll', onStickyBarScroll, { passive: true });
    applyStickyBarColors();
    onStickyBarScroll();
  }

  function applyZoraliColors() {
    var config = document.getElementById('zorali-pdp-config');
    if (!config) return;

    var bgColor = config.dataset.bg || '';
    var textColor = config.dataset.text || '';
    var isLightBg = bgColor && zoraliContrastColor(bgColor) === '#000000';

    // Keep contrast styling on a stable root element. Dawn and the legacy
    // product script can replace or restyle the submit button after load.
    document.documentElement.classList.toggle('zorali-light-pdp-color', Boolean(isLightBg));

    if (!bgColor && !textColor) return;

    if (!textColor && bgColor) {
      textColor = zoraliContrastColor(bgColor) || '';
    }

    document.querySelectorAll('.product-form__submit, .badge.price__badge-sale').forEach(function (el) {
      if (bgColor) {
        el.style.backgroundColor = bgColor;
        el.style.borderColor = bgColor;
      }
      if (textColor) {
        el.style.color = textColor;
      }
    });

    if (bgColor) {
      document.querySelectorAll('.utility-bar.gradient, .info_popup_main').forEach(function (el) {
        el.style.backgroundColor = bgColor;
      });

      document.querySelectorAll('.cart-count-bubble').forEach(function (el) {
        el.style.backgroundColor = bgColor;
        if (textColor) {
          el.style.color = textColor;
        }
      });
    }

    if (textColor) {
      document.querySelectorAll(
        '.localization-wrapper a, .announcemnt_bar_slider_inner a, .announcement-bar__link .icon-arrow, .announcement_button a, .announcement-bar__announcement p'
      ).forEach(function (el) {
        el.style.color = textColor;
        el.style.borderColor = textColor;
      });
    }
  }

  var cartObserverStarted = false;
  function initColorSync() {
    applyZoraliColors();

    if (!cartObserverStarted) {
      var cartTarget = document.querySelector('.header__icon--cart');
      if (cartTarget) {
        new MutationObserver(applyZoraliColors).observe(cartTarget, { childList: true, subtree: true });
        cartObserverStarted = true;
      }
    }
  }

  function getSectionId() {
    var productInfo = document.querySelector('product-info');
    return productInfo ? productInfo.dataset.section : null;
  }

  // Color swatches are separate Shopify products, not variants, so switching
  // colors would otherwise be a full page navigation. Instead, fetch just the
  // target product's re-rendered "main" section (the same Section Rendering
  // API Dawn itself uses for variant changes) and swap it in place — no
  // reload, no scroll jump, no font-swap flash, one fewer full page load per
  // click. Falls back to a real navigation if anything goes wrong.
  function swapToProduct(targetUrl, newTitle) {
    var sectionId = getSectionId();
    if (!sectionId) {
      window.location.href = targetUrl;
      return;
    }

    fetch(targetUrl + '?section_id=' + sectionId)
      .then(function (res) {
        if (!res.ok) throw new Error('zorali swatch swap: bad response');
        return res.text();
      })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var newSection = doc.getElementById('shopify-section-' + sectionId);
        var oldSection = document.getElementById('shopify-section-' + sectionId);
        if (!newSection || !oldSection) throw new Error('zorali swatch swap: section not found');

        // The section-only response has no <title> tag to read, so the
        // correct title (matching the theme's page_title/SEO override logic)
        // is passed in from the swatch link's data-title attribute instead.
        if (newTitle) document.title = newTitle;

        oldSection.replaceWith(newSection);
        history.pushState({ zoraliSwatchSwap: true }, '', targetUrl);

        // Scripts/inline scripts inserted via replaceWith never auto-execute
        // (a DOM quirk, not a bug), so re-apply what they would have done.
        applyStickyBarColors();
        onStickyBarScroll();
        applyZoraliColors();
        syncBtnPrice();
        refreshMetafieldSections(targetUrl);
      })
      .catch(function () {
        window.location.href = targetUrl;
      });
  }

  // Some sections below the main one are driven by per-product metafields
  // (e.g. "Designed for life outdoors" imagery, which is stored per colour).
  // They live outside the swapped main section, so the main swap alone leaves
  // them showing the previous colour until a full reload. Re-render each one
  // via its own Section Rendering API call. The section id is shared across
  // sibling products (same product template), so we read it from the current
  // DOM. Any failure just leaves the existing section in place — a stale
  // section is a far better outcome than a full page navigation.
  var METAFIELD_SECTION_SELECTORS = ['.features_section_main'];

  function refreshMetafieldSections(targetUrl) {
    METAFIELD_SECTION_SELECTORS.forEach(function (selector) {
      var el = document.querySelector(selector);
      var oldSection = el ? el.closest('.shopify-section') : null;
      if (!oldSection || !oldSection.id) return;
      var id = oldSection.id.replace(/^shopify-section-/, '');

      fetch(targetUrl + '?section_id=' + id)
        .then(function (res) { return res.ok ? res.text() : null; })
        .then(function (text) {
          if (!text || !text.trim()) return;
          var doc = new DOMParser().parseFromString(text, 'text/html');
          var newSection = doc.getElementById('shopify-section-' + id);
          if (newSection) oldSection.replaceWith(newSection);
        })
        .catch(function () {});
    });
  }

  function initSwatchSwap() {
    document.addEventListener('click', function (e) {
      var link = e.target.closest('.zorali-swatch-item');
      if (!link) return;
      e.preventDefault();
      if (link.classList.contains('zorali-swatch-item--active')) return;
      swapToProduct(link.href, link.dataset.title);
    });

    // Keep back/forward simple and correct rather than trying to restore
    // swapped-in state from history — a real reload is a fine trade-off for
    // the comparatively rare back-button case.
    window.addEventListener('popstate', function () {
      window.location.reload();
    });
  }

  function init() {
    initStickyBar();
    initColorSync();
    initSwatchSwap();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
